(function () {
  const initUspSlider = () => {
    const uspSwiper = document.querySelector('.usp-bar__swiper');
    if (!uspSwiper) return;

    const uspCount = parseInt(uspSwiper.dataset.uspCount || '0');
    if (uspCount <= 1) return;

    let swiperInstance;

    const initOrDestroySwiper = () => {
      const isMobile = window.innerWidth < 750;

      if (isMobile && !swiperInstance) {
        swiperInstance = new Swiper('.usp-bar__swiper', {
          slidesPerView: 1,
          loop: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          speed: 600,
        });
      } else if (!isMobile && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    };

    initOrDestroySwiper();
    window.addEventListener('resize', initOrDestroySwiper);
  };

  document.addEventListener('DOMContentLoaded', initUspSlider);
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.classList.contains('section-usp-bar')) {
      initUspSlider();
    }
  });
})();
